import {
    faArrowRight,
    faChevronDown,
    faUser,
    faShoppingCart,
    faListUl,
    faDollarSign,
    faLightbulb,
    faPhone,
    faSignOutAlt,
    faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { authActions } from "../../store/authSlice";

function MainMenu({ isOpen, setOpen }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation(); // Hook để lấy route hiện tại

    const handleLogOut = () => {
        dispatch(authActions.logout());
        localStorage.removeItem("access_token");
        localStorage.removeItem("user_info");
        navigate("/"); // Chuyển hướng về trang chủ sau khi đăng xuất
    };

    const [menu, setMenu] = useState([
        {
            id: 0,
            title: "Tải App Longhousee",
            hasChild: false,
            path: "/tai-app",
            icon: faDownload,
            highlight: true, // làm nổi bật bằng màu brand
        },
        {
            id: 1,
            title: "Tài khoản của tôi",
            hasChild: false,
            path: "/user-info",
            icon: faUser,
        },
        {
            id: 2,
            title: "Mua sắm hoàn tiền",
            hasChild: true,
            isOpen: false,
            icon: faShoppingCart,
            childs: [
                {
                    title: "Shopee",
                    path: "/shopee",
                },
                {
                    title: "TikTok",
                    path: "/tiktok",
                },
                {
                    title: "Lazada",
                    path: "/lazada",
                },
                {
                    title: "ShopeeFood",
                    path: "/shopeefood",
                },
            ],
        },
        {
            id: 3,
            title: "Danh mục tiện ích",
            hasChild: true,
            isOpen: false,
            icon: faListUl,
            childs: [
                {
                    title: "Đua top hoàn tiền",
                    path: "/top_cash_back",
                },
                {
                    title: "Đua top đơn hàng",
                    path: "/top_orders",
                },
                {
                    title: "Đổi voucher",
                    path: "/voucher",
                },
                {
                    title: "Giới thiệu bạn mới",
                    path: "/user-info/ref",
                },
                // {
                //     title: "Thưởng thêm hoàn tiền",
                //     path: "/bouns-cash",
                // },
            ],
        },
        {
            id: 4,
            title: "Shopee Xu",
            hasChild: false,
            path: "https://longhousee-shopeexu.vercel.app/",
            icon: faDollarSign,
        },
        {
            id: 5,
            title: "Mẹo săn sale",
            hasChild: false,
            path: "/post",
            icon: faLightbulb,
        },
        {
            id: 6,
            title: "Liên hệ",
            hasChild: true,
            isOpen: false,
            icon: faPhone,
            childs: [
                {
                    title: "Hỗ trợ",
                    path: "/support",
                },
                {
                    title: "Privacy Policy",
                    path: "/privacy",
                },
                {
                    title: "Terms",
                    path: "/terms",
                },
            ],
        },
    ]);

    const onOpen = (index) => {
        setMenu((prev) => {
            return prev.map((el) => ({
                ...el,
                isOpen: el.id === index ? !el.isOpen : el.isOpen,
            }));
        });
    };

    const handleLinkClick = (path) => {
        if (location.pathname === path) {
            setOpen(false); // Đóng menu nếu đường dẫn hiện tại khớp với đường dẫn của liên kết đã chọn
        }
    };

    return (
        <div
            className={`fixed top-0 h-dvh bg-gray-800 bg-opacity-80 ${
                isOpen ? "w-full" : "w-0"
            }`}
            onClick={() => isOpen && setOpen(false)} // Đóng menu nếu nhấn vào vùng tối
        >
            <div
                className={`${
                    isOpen ? "w-4/5" : "w-0"
                } fixed top-0 h-dvh shadow-lg border rounded-tl-3xl bg-surface z-50 right-0 overflow-hidden transition-all`}
                onClick={(e) => e.stopPropagation()} // Ngăn không đóng menu khi nhấn vào bên trong menu
            >
                <div className="p-4 flex flex-col h-full">
                    <div className="flex gap-2 items-center justify-between h-16 font-semibold mb-3">
                        <div className="h-full flex items-center rounded-lg">
                            <img
                                className="h-full object-cover"
                                src="/img/brand-logo/longhousee.png"
                                alt="logo-longhousee"
                            />
                            <div className="font-lexend flex flex-col justify-center items-start text-left text-sm font-bold leading-4 text-brand-coral">
                                <span className="px-1">SĂN SALE CÙNG</span>
                                <span className="px-1">LONGHOUSEE</span>
                            </div>
                        </div>
                        <div
                            className="text-xl h-full flex items-center px-3"
                            onClick={() => setOpen(false)}
                        >
                            <FontAwesomeIcon icon={faArrowRight} />
                        </div>
                    </div>
                    {menu.map((el) => (
                        <div
                            key={el.id}
                            className="cursor-pointer text-xl mb-2"
                            onClick={el.onClick ? el.onClick : undefined} // Đảm bảo hành động đăng xuất được kích hoạt
                        >
                            {!el.hasChild && !el.onClick && (
                                <Link
                                    className={`py-1 font-semibold flex items-center gap-2 ${
                                        el.highlight ? "text-brand-red" : ""
                                    }`}
                                    to={el.path}
                                    onClick={() => handleLinkClick(el.path)} // Đóng menu nếu đường dẫn khớp với route hiện tại
                                >
                                    <FontAwesomeIcon icon={el.icon} />
                                    {el.title}
                                </Link>
                            )}
                            {el.hasChild && (
                                <div
                                    onClick={() => onOpen(el.id)}
                                    className="flex items-center gap-2 font-semibold"
                                >
                                    <FontAwesomeIcon icon={el.icon} />
                                    <span>{el.title}</span>
                                    <FontAwesomeIcon
                                        icon={faChevronDown}
                                        className="text-base"
                                    />
                                </div>
                            )}
                            {el.hasChild && el.isOpen && (
                                <div className="px-3 mt-2">
                                    {el.childs.map((child) => (
                                        <Link
                                            className="pb-2 block"
                                            to={child.path}
                                            key={child.title}
                                            onClick={() =>
                                                handleLinkClick(child.path)
                                            } // Đóng menu nếu đường dẫn khớp với route hiện tại
                                        >
                                            <div>{child.title}</div>
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                    <div
                        className="mt-auto cursor-pointer text-xl mb-1 flex items-center gap-2 py-1 font-semibold"
                        onClick={handleLogOut}
                    >
                        <FontAwesomeIcon
                            icon={faSignOutAlt}
                            className="text-base"
                        />
                        <span>Đăng xuất</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MainMenu;
